export type Sku = string & { readonly __brand: 'Sku' };

export function sku(value: string): Sku {
  if (!value || value.trim().length === 0) {
    throw new Error('SKU cannot be empty');
  }
  return value as Sku;
}
